export default __webpack_public_path__ + "static/media/turtle.63aa63ef.png";